import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Modal, Spinner } from "@ster/ster-toolkit";
import { App, Form } from "antd";

import {
  AdvertiserRegistration,
  usePostApiV1AdvertiserRegisterAdvertiserMutation,
} from "../../store/coreApi";
import AdvertiserRegistrationForm from "./AdvertiserRegistrationForm";

const AdvertiserRegistrationModal = ({
  open,
  onFinish,
}: {
  open: boolean | undefined;
  onFinish: () => void;
}) => {
  const i18n = useLingui();
  const { message } = App.useApp();
  const [form] = Form.useForm<AdvertiserRegistration>();

  const [postAdvertiserRegistration, { isLoading }] =
    usePostApiV1AdvertiserRegisterAdvertiserMutation();

  const handleOk = async () => {
    const values = await form.validateFields();
    try {
      await postAdvertiserRegistration({
        advertiserRegistration: values,
      }).unwrap();
      message.success(i18n._(t`Nieuwe adverteerder is aangevraagd.`));
      onFinish();
    } catch {
      message.error(
        i18n._(t`Er is iets misgegaan bij het aanvragen van de adverteerder.`)
      );
    }
  };

  return (
    <Modal
      open={open === true}
      title={i18n._(t`Nieuwe adverteerder`)}
      onCancel={onFinish}
      onOk={handleOk}
    >
      <Spinner spinning={isLoading}>
        <AdvertiserRegistrationForm form={form} />
      </Spinner>
    </Modal>
  );
};

export default AdvertiserRegistrationModal;
